import { useEffect, useMemo } from "react";
import PricingCard from "./PricingCard";
import { useAuth0 } from "@auth0/auth0-react";
import { useStripeContext } from "../../StripeProvider";
import { isReauthInProgressError, withTokenRecovery } from "../../utils/tokenUtils";

const Pricing = () => {
    const { isAuthenticated, isLoading, user, getAccessTokenSilently, loginWithRedirect } = useAuth0();
    const { setClientSecret } = useStripeContext();


    useEffect(() => {
        if (isLoading || !user) return;

        const fetchClientSecret = async () => {
            try {
                const authApiCall = withTokenRecovery({
                    getAccessTokenSilently,
                    loginWithRedirect,
                    audience: process.env.REACT_APP_DEV_PORTAL_API_SERVER,
                    context: "pricing",
                    returnTo: "/",
                });

                const response = await authApiCall(async (token) =>
                    fetch(`${process.env.REACT_APP_DEV_PORTAL_API_SERVER}/stripe/customer_session`, {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    })
                );

                if (!response.ok) {
                    const error = new Error(`HTTP error! status: ${response.status}`);
                    error.status = response.status;
                    throw error;
                }

                const clientSecret = await response.text();
                setClientSecret(clientSecret);
                console.log('Stripe client secret obtained successfully');
            } catch (error) {
                if (isReauthInProgressError(error)) return;
                console.error('Error fetching client secret:', error);
            }
        };

        fetchClientSecret();
    }, [user, isLoading, getAccessTokenSilently, loginWithRedirect, setClientSecret])



    const PRICING = useMemo(
        () => [
            {
                id: 1,
                active: !isAuthenticated,
                title: "Trial AI",
                price: "Free",
                period: "",
                list: [
                    "100 Calls (Lifetime)",
                    "Business Hours Support",
                    "For Unlimited Time",
                ],
                buttonText: "Sign Up",
                type: "TRIAL"
            },
            {
                id: 2,
                active: true,
                title: "Starter",
                price: "$5",
                // period: "per month",
                list: [
                    "100 Calls (Lifetime)",
                    "Business Hours Support",
                    "Free for 30 Days",
                ],
                buttonText: "Purchase",
                type: "STARTER"
            },
            {
                id: 3,
                active: true,
                title: "Enterprise",
                price: "Request quote",
                // period: "per month",
                list: [
                    "50,000 Calls (Monthly)",
                    "Business Hours Support",
                    "Free for 30 Days",
                ],
                buttonText: "Contact Us",
                type: "ENTERPRISE"
            },
        ],
        [isAuthenticated]
    );


    return (
        <section>
            <div className="container flex flex-col items-center justify-center gap-8 mx-auto text-center">
                <h2
                    className={`text-[3rem] md:text-[4.8rem] text-white font-bold leading-[3.6rem] md:leading-[7.2rem]
                `}
                >
                    Simple, Affordable Pricing
                </h2>
                <p className="mb-6 max-w-[76.8rem] text-[1.6rem] md:text-[2rem]">
                    Experience the industry's lowest prices with our ARES API's
                    top-up model. No monthly subscriptions, just pay for the
                    credits you need. The more you order, the lower the cost per
                    query. The pricing and other options will open up soon.
                    <span>
                        Contact us at{" "}
                        <a
                            className="text-accent underline"
                            href="mailto:sales@traversaal.ai"
                        >
                            sales@traversaal.ai
                        </a>{" "}
                        for getting access to enterprise version.
                    </span>
                </p>
            </div>


            <div className="flex my-16 gap-[2rem] justify-center flex-wrap">
                {PRICING.map((item) => {
                    return (
                        <PricingCard
                            buttonText={item.buttonText}
                            key={item.id}
                            title={item.title}
                            price={item.price}
                            active={item.active}
                            period={item.period}
                            list={item.list}
                            type={item.type}
                        />
                    );
                })}
            </div>
        </section>
    );
};
export default Pricing;
